module.exports = __webpack_public_path__ + "static/media/aMediaWhite.120b1c3a.png";